export default __webpack_public_path__ + "static/media/PlasmidDesign_FR.96d8bf6b.pdf";